export default class MissingAccountPermissionException extends Error {
  constructor(...args) {
    super(...args);
    this.message = 'user is missing required account permission(s).';
  }
}
